import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "lotAreaWrapper",
    "montantLoyerInput",
    "montantChargesInput",
    "totalRentAmount",
    "rentForm",
    "addPhotosButton",
    "firstBatchPhotos",
    "lastBatchPhotos",
    "mobileStepsWrapper",
    "searchAnnonceTrigger",
    "searchAnnonceFormWrapper"
  ]

  _lotAreaInput = null;

  connect() {
    if (this.hasLotAreaWrapperTarget) {
      this._lotAreaInput = this.lotAreaWrapperTarget.querySelector("input");
    }
  }

  hideLotAreaWrapper() {
    this._lotAreaInput.value = '';
    this.lotAreaWrapperTarget.style.display = 'none';
  }

  showLotAreaWrapper() {
    this.lotAreaWrapperTarget.style.display = 'block';
  }

  updateTotalRentAmount() {
    let rentAmount = parseFloat(this.montantLoyerInputTarget.value) || 0;
    let chargesAmount = parseFloat(this.montantChargesInputTarget.value) || 0;
    let totalAmount = (rentAmount + chargesAmount).toFixed(2);
    this.totalRentAmountTarget.textContent = totalAmount;
  }

  submitForm() {
    let rentForm = document.querySelector("[data-app--proprietaire--add-annonce-target='rentForm']");
    rentForm.submit();
  }

  addPhotos() {
    if (this.firstBatchPhotosTarget.classList.contains("hidden")) {
      this.firstBatchPhotosTarget.classList.remove("hidden");
    } else {
      this.lastBatchPhotosTarget.classList.remove("hidden");
      this.addPhotosButtonTarget.classList.add("hidden");
    }
  }

  closeMobileStepsWrapper() {
    if (!this.mobileStepsWrapperTarget.classList.contains('hidden')) {
      this.mobileStepsWrapperTarget.classList.add('hidden');
    }
  }

  openMobileStepsWrapper() {
    if (this.mobileStepsWrapperTarget.classList.contains('hidden')) {
      this.mobileStepsWrapperTarget.classList.remove('hidden');
    }
  }

  showSearchAnnonceForm() {
    if (this.searchAnnonceFormWrapperTarget.classList.contains("hidden")) {
      this.searchAnnonceFormWrapperTarget.classList.remove("hidden");
    }
    this.searchAnnonceTriggerTarget.classList.add("hidden");
  }
}
